export default "assets/images/icons/mail-33cda9fa.svg";